<ng-container #widgetContainer></ng-container>
